import weddingOpenDay from './../assets/images/Weddings/civilCeremonies.webp'

const WeddingOpenDay = () => {
  return (
    <div className="flex flex-col md:flex-row items-center gap-8 p-6 md:p-12 bg-gray-100 rounded-xl shadow-lg mt-16">
      <img 
        src={weddingOpenDay} 
        alt="Wedding Open Day" 
        className="w-full md:w-1/2 h-64 object-cover rounded-lg"
      />
      <div className="md:w-1/2 text-center md:text-left">
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Wedding Open Day</h2>
        <p className="text-gray-600 mb-4">
          Saturday 14th March 🕚 11:00am till 3:30pm        
        </p>
        <p className="text-gray-600 mb-4">
          Planning your 2027/28 wedding? Join us at The Fox Inn, Stourton for our exclusive Wedding Open Day on the Saturday of Mother's Day weekend.
        </p>
        <p className="text-gray-600 mb-4">
          What's waiting for you: 🥂 A Warm Welcome: Enjoy a chilled glass of Prosecco on arrival. 🍴 A Taste of The Fox: Sample our chef's signature wedding canapés.  
        </p>
        <p className="text-gray-600 mb-4">
          Meet the Experts: Get inspired by our handpicked preferred suppliers, including the amazing styling of JC Events Stourbridge 
          Ltd and stunning displays from Airdorable. We will also have expert local photographers, florists, and cake designers all to be announced.         
        </p>
        <p className="text-gray-600 mb-4">
          Entry is free, but please register for your ticket via Eventbrite! 
        </p>
        <div className="flex flex-col sm:flex-row gap-4 mt-4">
          <a href="https://www.eventbrite.co.uk/e/wedding-open-day-tickets-1980483897651?aff=oddtdtcreator&fbclid=IwY2xjawPcSHpleHRuA2FlbQIxMABicmlkETAxWUxTdmhINk5iVk42YlFNc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHmFwFxoJAQlAn95izSzE2Fyap4m2XpLuD3moJyzKVs9fwGpj2hXZp9SMN2xP_aem_9d3QXnlqBpuY-t3PsiA-HQ" rel="noopener noreferrer" className="border-2 border-gray-700 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-700 hover:text-white transition duration-300 shadow-md">
            Reserve Online
          </a>
          <a href="tel:01384872614" rel="noopener noreferrer" className="bg-gray-700 text-white px-6 py-2 rounded-full hover:bg-gray-800 transition duration-300 shadow-md">
            Call: 01384 872614
          </a>
        </div>
      </div>
    </div>
  );
};

export default WeddingOpenDay;